// extracted by mini-css-extract-plugin
export var blockBtn = "courseTopics-module--block-btn--85fda";
export var courseTopics = "courseTopics-module--course-topics--f4e33";
export var courseTopics__information = "courseTopics-module--course-topics__information--8b95a";
export var courseTopics__list = "courseTopics-module--course-topics__list--f3bee";
export var courseTopics__logo = "courseTopics-module--course-topics__logo--da24b";
export var courseTopics__subtitle = "courseTopics-module--course-topics__subtitle--2b3b7";
export var courseTopics__text = "courseTopics-module--course-topics__text--83148";
export var courseTopics__title = "courseTopics-module--course-topics__title--5faf8";
export var courseTopics__topic = "courseTopics-module--course-topics__topic--34594";
export var courseTopics__topicLarge = "courseTopics-module--course-topics__topic--large--d870d";
export var courseTopics__wrapper = "courseTopics-module--course-topics__wrapper--0a001";
export var mainBtn = "courseTopics-module--main-btn--f210f";
export var mainTitle = "courseTopics-module--main-title--89080";
export var title = "courseTopics-module--title--36d94";